import React, { useState, useEffect, useRef, useMemo } from "react";
import { useSelector } from "react-redux";
import ApexSankey from "apexsankey"; // ApexSankey'i import edin
import { theme } from "antd";

export default function InsightSankey() {
  const themeMode = useSelector((state) => state.themeMode);
  const topMenuTabs = useSelector((state) => state.topMenuTabs);
  const currentSurveyInsightData = topMenuTabs.tabs.find(
    (tab) => tab.id === topMenuTabs.activeTab
  ).states.currentSurveyInsightData;

  const [selectedQuestion, setSelectedQuestion] = useState(null);
  const [secondSelectedQuestion, setSecondSelectedQuestion] = useState(null);
  const [thirdSelectedQuestion, setThirdSelectedQuestion] = useState(null);

  const chartRef = useRef(null); // DOM elemanına referans
  const firstMenuRef = useRef(null);
  const secondMenuRef = useRef(null);
  const thirdMenuRef = useRef(null);
  const [data, setData] = useState({ nodes: [], edges: [] });
  const [isOpenFirstMenu, setIsOpenFirstMenu] = useState(false);
  const [isOpenSecondMenu, setIsOpenSecondMenu] = useState(false);
  const [isOpenThirdMenu, setIsOpenThirdMenu] = useState(false);
  // const [data, setData] = useState({ nodes: [
  //     {id: 'England', title: 'england'},
  //     {id: 'Wales', title: 'wales'},
  //     {id: 'Level 4', title: 'level 4'},
  //     {id: 'Level 3', title: 'level 3'},
  //     {id: 'Level 2', title: 'level 2'},
  //     {id: 'Level 1 and entry level', title: 'level 1 and entry level'},
  //     {id: 'No qualifications', title: 'no qualifications'},
  //     {id: 'Other', title: 'other'},
  //     {id: 'Wholesale & retail', title: 'wholesale & retail'},
  //     {id: 'Health & social work', title: 'health & social work'},
  //     {id: 'Education', title: 'education'},
  //     {id: 'Construction', title: 'construction'},
  //     {id: 'Manufacturing', title: 'manufacturing'},
  //     {id: 'Transport & storage', title: 'transport & storage'},
  //     {id: 'Finance & insurance', title: 'finance & insurance'},
  //   ],
  //   edges: [
  //     {source: 'England', target: 'Level 4', value: 13},
  //     {source: 'England', target: 'Level 3', value: 8},
  //     {source: 'England', target: 'Level 2', value: 8},
  //     {source: 'England', target: 'Level 1 and entry level', value: 6},
  //     {source: 'England', target: 'No qualifications', value: 3},
  //     {source: 'Wales', target: 'Level 4', value: 7},
  //     {source: 'Wales', target: 'Level 3', value: 8},
  //     {source: 'Wales', target: 'Level 2', value: 4},
  //     {source: 'Wales', target: 'Level 1 and entry level', value: 5},
  //     {source: 'Wales', target: 'No qualifications', value: 5},
  //     {source: 'Level 4', target: 'Wholesale & retail', value: 4},
  //     {source: 'Level 4', target: 'Health & social work', value: 3},
  //     {source: 'Level 4', target: 'Education', value: 2},
  //     {source: 'Level 4', target: 'Construction', value: 1},
  //     {source: 'Level 4', target: 'Manufacturing', value: 2},
  //     {source: 'Level 4', target: 'Other', value: 3},
  //     {source: 'Level 4', target: 'Transport & storage', value: 2},
  //     {source: 'Level 4', target: 'Finance & insurance', value: 3},
  //     {source: 'Level 3', target: 'Wholesale & retail', value: 3},
  //     {source: 'Level 3', target: 'Health & social work', value: 2},
  //     {source: 'Level 3', target: 'Education', value: 1},
  //     {source: 'Level 3', target: 'Construction', value: 2},
  //     {source: 'Level 3', target: 'Manufacturing', value: 1},
  //     {source: 'Level 3', target: 'Other', value: 3},
  //     {source: 'Level 3', target: 'Transport & storage', value: 2},
  //     {source: 'Level 3', target: 'Finance & insurance', value: 2},
  //     {source: 'Level 2', target: 'Wholesale & retail', value: 2},
  //     {source: 'Level 2', target: 'Health & social work', value: 1},
  //     {source: 'Level 2', target: 'Education', value: 2},
  //     {source: 'Level 2', target: 'Construction', value: 1},
  //     {source: 'Level 2', target: 'Manufacturing', value: 2},
  //     {source: 'Level 2', target: 'Other', value: 2},
  //     {source: 'Level 2', target: 'Transport & storage', value: 1},
  //     {source: 'Level 2', target: 'Finance & insurance', value: 1},
  //     {source: 'Level 1 and entry level', target: 'Wholesale & retail', value: 1},
  //     {source: 'Level 1 and entry level', target: 'Health & social work', value: 2},
  //     {source: 'Level 1 and entry level', target: 'Education', value: 1},
  //     {source: 'Level 1 and entry level', target: 'Construction', value: 2},
  //     {source: 'Level 1 and entry level', target: 'Manufacturing', value: 1},
  //     {source: 'Level 1 and entry level', target: 'Other', value: 2},
  //     {source: 'Level 1 and entry level', target: 'Transport & storage', value: 1},
  //     {source: 'Level 1 and entry level', target: 'Finance & insurance', value: 1},
  //     {source: 'No qualifications', target: 'Wholesale & retail', value: 1},
  //     {source: 'No qualifications', target: 'Health & social work', value: 1},
  //     {source: 'No qualifications', target: 'Education', value: 1},
  //     {source: 'No qualifications', target: 'Construction', value: 1},
  //     {source: 'No qualifications', target: 'Manufacturing', value: 1},
  //     {source: 'No qualifications', target: 'Other', value: 1},
  //     {source: 'No qualifications', target: 'Transport & storage', value: 1},
  //     {source: 'No qualifications', target: 'Finance & insurance', value: 1},
  //   ], });
  const [graphOptions, setGraphOptions] = useState({});

  const generateNodeColors = (edges) => {
    let colorMap = {};
    let colorList = ["#FF5733", "#33FF57", "#3357FF", "#F39C12", "#9B59B6"]; // Renk paleti
    let colorIndex = 0;
    const nodes = new Set();

    // Tüm source ve target node'ları topla
    edges.forEach((edge) => {
      nodes.add(edge.source.split("_")[0]);
      nodes.add(edge.target.split("_")[0]);
    });

    // Node gruplarını aynı renkte yap
    nodes.forEach((nodeGroup) => {
      colorMap[nodeGroup] = colorList[colorIndex % colorList.length];
      colorIndex++;
    });
    return colorMap;
  };

  useEffect(() => {
    setGraphOptions({
      nodeWidth: 10,
      edgeOpacity: 0.4,
      edgeGradientFill: true,
      fontFamily: "Quicksand, sans-serif",
      fontWeight: "600",
      height: "600px",
      enableToolbar: false,
      canvasStyle: "border: 0px solid #caced0",
      fontColor: themeMode === "dark" ? "#ffffff" : "#000000", // Node label rengi
      tooltipBorderColor: themeMode === "dark" ? "#BCBCBC" : "#CCCCCC",
      tooltipBGColor: themeMode === "dark" ? "#000000" : "#FFFFFF",
    });
  }, [themeMode]);

  useEffect(() => {
    if (
      !data ||
      !data.edges ||
      !Array.isArray(data.edges) ||
      !data.edges.length ||
      !data.nodes ||
      !Array.isArray(data.nodes) ||
      !data.nodes.length
    ) {
      // console.error("Data, edges veya nodes dizisi eksik veya yanlış formatta.");
      return;
    }
    const nodeColorMap = generateNodeColors(data.edges);
    const updatedNodes = data.nodes.map((node) => {
      const nodeGroup = node.id.split("_")[0];
      return {
        ...node,
        color: nodeColorMap[nodeGroup] || "#CCCCCC", // 🔴 Renk yoksa default gri
      };
    });
    const newData = {
      ...data,
      nodes: updatedNodes,
    };

    setTimeout(() => {
      if (chartRef.current) {
        chartRef.current.innerHTML = "";
        const sankey = new ApexSankey(chartRef.current, graphOptions);
        sankey.render(newData); // 🔴 Güncellenmiş `data` render ediliyor
      }
    }, 1);
  }, [data, themeMode]);

  const handleClickOutside = (event, ref, setState) => {
    if (ref.current && !ref.current.contains(event.target)) {
      setState(false);
    }
  };
  useEffect(() => {
    if (isOpenFirstMenu) {
      document.addEventListener("click", (event) =>
        handleClickOutside(event, firstMenuRef, setIsOpenFirstMenu)
      );
    }

    if (isOpenSecondMenu) {
      document.addEventListener("click", (event) =>
        handleClickOutside(event, secondMenuRef, setIsOpenSecondMenu)
      );
    }
    if (isOpenThirdMenu) {
      document.addEventListener("click", (event) =>
        handleClickOutside(event, thirdMenuRef, setIsOpenThirdMenu)
      );
    }
    return () => {
      document.removeEventListener("click", (event) =>
        handleClickOutside(event, firstMenuRef, setIsOpenFirstMenu)
      );
      document.removeEventListener("click", (event) =>
        handleClickOutside(event, secondMenuRef, setIsOpenSecondMenu)
      );
      document.removeEventListener("click", (event) =>
        handleClickOutside(event, thirdMenuRef, setIsOpenThirdMenu)
      );
    };
  }, [isOpenFirstMenu, isOpenSecondMenu, isOpenThirdMenu]);
  const uppdateSankeyChart = (order, question) => {
   
    let _data = { nodes: [], edges: [] };
    if (order === "first") {
      setSelectedQuestion(question);
      question.options.forEach((option) => {
        _data.nodes.push({
          id: question.question + "_" + option,
          title: option,
        });
      });
      if (secondSelectedQuestion) {
        secondSelectedQuestion.options.forEach((option) => {
          _data.nodes.push({
            id: secondSelectedQuestion.question + "_" + option,
            title: option,
          });
        });
      }
      if (thirdSelectedQuestion) {
        thirdSelectedQuestion.options.forEach((option) => {
          _data.nodes.push({
            id: thirdSelectedQuestion.question + "_" + option,
            title: option,
          });
        });
      }
    } else if (order === "second") {
      setSecondSelectedQuestion(question);
      question.options.forEach((option) => {
        _data.nodes.push({
          id: question.question + "_" + option,
          title: option,
        });
      });
      if (selectedQuestion) {
        selectedQuestion.options.forEach((option) => {
          _data.nodes.push({
            id: selectedQuestion.question + "_" + option,
            title: option,
          });
        });
      }
      if (thirdSelectedQuestion) {
        thirdSelectedQuestion.options.forEach((option) => {
          _data.nodes.push({
            id: thirdSelectedQuestion.question + "_" + option,
            title: option,
          });
        });
      }
    } else if (order === "third") {
      setThirdSelectedQuestion(question);
      question.options.forEach((option) => {
        _data.nodes.push({
          id: question.question + "_" + option,
          title: option,
        });
      });
      if (selectedQuestion) {
        selectedQuestion.options.forEach((option) => {
          _data.nodes.push({
            id: selectedQuestion.question + "_" + option,
            title: option,
          });
        });
      }
      if (secondSelectedQuestion) {
        secondSelectedQuestion.options.forEach((option) => {
          _data.nodes.push({
            id: secondSelectedQuestion.question + "_" + option,
            title: option,
          });
        });
      }
    }

    let _answers = currentSurveyInsightData.report_detail.survey_answers.map((answerGroup) => {
      return answerGroup.answers.map((a) => {
        let cleanedAnswer = { ...a }; // orijinal objeyi kopyala
        if (typeof a.answer === "object" && a.answer !== null && "Current" in a.answer) {
          cleanedAnswer.answer = a.answer.Current;
        }
        return cleanedAnswer;
      });
    });
    // if (order === 'second') {
    //     selectedQuestion.options.forEach((option) => {
    //         let filtered_answer = _answers.filter((user_answer_list) => user_answer_list.find((user_answer) => user_answer.question === selectedQuestion.question && user_answer.answer === option));
    //         if (filtered_answer?.length > 0) {
    //             question.options.forEach((second_option) => {
    //                 let total_second_answer = filtered_answer.filter((user_answer_list) => user_answer_list.find((user_answer) => user_answer.question === question.question && user_answer.answer === second_option))?.length;
    //                 if (total_second_answer > 0) {
    //                     _data.edges.push({ source: selectedQuestion.question + "_" + option, target: question.question + "_" + second_option, value: total_second_answer });
    //                 }
    //             });
    //         }
    //     });
    // } else
    if (secondSelectedQuestion !== null) {
      selectedQuestion.options.forEach((option) => {
        let filtered_answer = _answers.filter((user_answer_list) =>
          user_answer_list.find(
            (user_answer) =>
              user_answer.question === selectedQuestion.question &&
              user_answer.answer === option
          )
        );
        if (filtered_answer?.length > 0) {
          secondSelectedQuestion.options.forEach((second_option) => {
            let total_second_answer = filtered_answer.filter(
              (user_answer_list) =>
                user_answer_list.find(
                  (user_answer) =>
                    user_answer.question === secondSelectedQuestion.question &&
                    user_answer.answer === second_option
                )
            )?.length;
            if (total_second_answer > 0) {
              _data.edges.push({
                source: selectedQuestion.question + "_" + option,
                target: secondSelectedQuestion.question + "_" + second_option,
                value: total_second_answer,
              });
            }
          });
        }
      });
    }
    // if (order === 'third') {
    //     secondSelectedQuestion.options.forEach((option) => {
    //         let filtered_answer = _answers.filter((user_answer_list) => user_answer_list.find((user_answer) => user_answer.question === secondSelectedQuestion.question && user_answer.answer === option));
    //         if (filtered_answer?.length > 0) {
    //             question.options.forEach((second_option) => {
    //                 let total_second_answer = filtered_answer.filter((user_answer_list) => user_answer_list.find((user_answer) => user_answer.question === question.question && user_answer.answer === second_option))?.length;
    //                 if (total_second_answer > 0) {
    //                     _data.edges.push({ source: secondSelectedQuestion.question + "_" + option, target: question.question + "_" + second_option, value: total_second_answer });
    //                 }
    //             });
    //         }
    //     });
    // } else
    if (thirdSelectedQuestion !== null) {
      secondSelectedQuestion.options.forEach((option) => {
        let filtered_answer = _answers.filter((user_answer_list) =>
          user_answer_list.find(
            (user_answer) =>
              user_answer.question === secondSelectedQuestion.question &&
              user_answer.answer === option
          )
        );
        if (filtered_answer?.length > 0) {
          thirdSelectedQuestion.options.forEach((second_option) => {
            let total_second_answer = filtered_answer.filter(
              (user_answer_list) =>
                user_answer_list.find(
                  (user_answer) =>
                    user_answer.question === thirdSelectedQuestion.question &&
                    user_answer.answer === second_option
                )
            )?.length;
            if (total_second_answer > 0) {
              _data.edges.push({
                source: secondSelectedQuestion.question + "_" + option,
                target: thirdSelectedQuestion.question + "_" + second_option,
                value: total_second_answer,
              });
            }
          });
        }
      });
    }

    setData({ ..._data });
  };

  useEffect(() => {
    if (selectedQuestion) {
      uppdateSankeyChart("first", selectedQuestion);
    }
  }, [selectedQuestion]);

  useEffect(() => {
    if (secondSelectedQuestion) {
      uppdateSankeyChart("second", secondSelectedQuestion);
    }
  }, [secondSelectedQuestion]);

  useEffect(() => {
    if (thirdSelectedQuestion) {
      uppdateSankeyChart("third", thirdSelectedQuestion);
    }
  }, [thirdSelectedQuestion]);


  useEffect(
    (graphOptions) => {
      if (currentSurveyInsightData) {
        if (
          currentSurveyInsightData?.report_detail?.survey_answers?.length > 0
        ) {
          let answers = [
            ...currentSurveyInsightData.report_detail.survey_answers[0][
              "answers"
            ].filter(
              (answer) =>
                answer.type === "radiogroup" || answer.type === "dropdown"
            ),
          ];
          const groupedArray = Object.values(
            answers.reduce((acc, item) => {
              const { page, question, options } = item; // `a`'yı anahtar olarak al, geri kalanı `rest` olarak ayır
              if (!acc[page]) {
                acc[page] = { page, questions: [] }; // Eğer grup yoksa oluştur
              }
              acc[page].questions.push({
                question: question,
                options: options,
              }); // Diğer verileri gruba ekle
              return acc;
            }, {})
          );
          setOptions(groupedArray);
        }
      }
    },
    [currentSurveyInsightData]
  );

  // Dropdown verileri (gruplu yapı)
  const [options, setOptions] = useState([
    // {
    //     group: "Fruits",
    //     items: ["Apple", "Banana", "Cherry"],
    // },
    // {
    //     group: "Vegetables",
    //     items: ["Carrot", "Broccoli", "Spinach"],
    // },
    // {
    //     group: "Dairy",
    //     items: ["Milk", "Cheese", "Yogurt"],
    // }
  ]);

  return (
    <div
      className={`flex flex-col w-full pt-4 ${
        themeMode === "dark"
          ? "bg-[#1a1a28] text-white"
          : "bg-[#fbfbfc] text-black"
      }`}
    >
      <div className="grid grid-cols-1 lg:grid-cols-2 spacey-8 xl:grid-cols-3 justify-evenly place-items-center items-start">
        <div className="relative inline-block text-left " ref={firstMenuRef}>
          <button
            onClick={() => {
              setIsOpenFirstMenu(!isOpenFirstMenu);
              if (isOpenSecondMenu) {
                setIsOpenSecondMenu(false);
              }
              if (isOpenThirdMenu) {
                setIsOpenThirdMenu(false);
              }
            }}
            className={`hulyButton font-medium-14 h-[1.5rem] lg:h-[2rem] w-64 px-2 border rounded-[0.375rem] cursor-pointer flex justify-center  items-center gap-2 ${
              themeMode === "dark"
                ? "border-[#d1d5de0a] bg-[#d1d5de0d] hover:bg-[#d1d5de0a] hover:text-[#fff] text-white-8"
                : "border-[#1725471a] bg-[#1725470d] hover:bg-[#1725471a] hover:text-[#000] text-black-8"
            }`}
          >
            <div className="truncate">
              {selectedQuestion ? selectedQuestion.question : "Add a question"}
            </div>
            <svg
              className="w-5 h-5 ml-2 -mr-1"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 20 20"
              fill="currentColor"
              aria-hidden="true"
            >
              <path
                fillRule="evenodd"
                d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                clipRule="evenodd"
              />
            </svg>
          </button>

          {isOpenFirstMenu && (
            <div
              className={`absolute left-1 z-[99999999]  w-64  h-[250px] overflow-y-scroll  origin-top-right rounded-md shadow-2xl ring-1 ring-black/5 transition focus:outline-none data-[closed]:scale-95 data-[closed]:transform data-[closed]:opacity-0 data-[enter]:duration-100 data-[leave]:duration-75 data-[enter]:ease-out data-[leave]:ease-in  border-solid border-[1px] ${
                themeMode === "dark"
                  ? " bg-[#2a2939] border-white-09 shadow-theme-popup-shadow "
                  : "bg-[#FFFFFF] border-black-09 shadow-black-2-shadow"
              }`}
            >
              <div className="py-1">
                {options.map((group) => (
                  <div key={group.page}>
                    <div
                      className={`flex-shrink-0 flex justify-between px-2 py-1 min-w-0 min-h-[2.25rem] text-left rounded-md cursor-pointer font-bold ${
                        themeMode === "dark"
                          ? " text-blue-500"
                          : " text-blue-500"
                      }`}
                    >
                      {group.page}
                    </div>
                    {group.questions.map((item) => (
                      <button
                        key={item.question}
                        className={`flex-shrink-0 flex justify-between px-2 py-1 min-w-0 min-h-[2.25rem] text-left rounded-md cursor-pointer ${
                          themeMode === "dark"
                            ? "hover:bg-[#333240] text-white"
                            : "hover:bg-[#EBEBEB] text-black"
                        }`}
                        onClick={() => {
                          // setSelectedQuestion(item);
                          setIsOpenFirstMenu(false);
                          // uppdateSankeyChart('first', item);
                          setSelectedQuestion(item);
                        }}
                      >
                        {item.question}
                      </button>
                    ))}
                  </div>
                ))}
              </div>
            </div>
          )}
          <div className="w-64 break-words whitespace-wrap my-4">
            {selectedQuestion ? selectedQuestion.question : ""}
          </div>
        </div>
        <div
          className="relative inline-block text-left mt-4 sm:mt-0"
          ref={secondMenuRef}
        >
          <button
            onClick={() => {
              setIsOpenSecondMenu(!isOpenSecondMenu);
              if (isOpenFirstMenu) {
                setIsOpenFirstMenu(false);
              }
              if (isOpenThirdMenu) {
                setIsOpenThirdMenu(false);
              }
            }}
            disabled={!selectedQuestion}
            className={`hulyButton font-medium-14 h-[1.5rem] lg:h-[2rem] w-64 px-2 border rounded-[0.375rem] cursor-pointer flex justify-center  items-center gap-2 ${
              themeMode === "dark"
                ? "border-[#d1d5de0a] bg-[#d1d5de0d] hover:bg-[#d1d5de0a] hover:text-[#fff] text-white-8"
                : "border-[#1725471a] bg-[#1725470d] hover:bg-[#1725471a] hover:text-[#000] text-black-8"
            }`}
          >
            <div className="truncate">
              {secondSelectedQuestion
                ? secondSelectedQuestion.question
                : "Add a question"}
            </div>
            <svg
              className="w-5 h-5 ml-2 -mr-1"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 20 20"
              fill="currentColor"
              aria-hidden="true"
            >
              <path
                fillRule="evenodd"
                d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                clipRule="evenodd"
              />
            </svg>
          </button>

          {isOpenSecondMenu && (
            <div
              className={`absolute left-1 z-[99999999]  w-64 h-[250px] overflow-y-scroll  origin-top-right rounded-md shadow-2xl ring-1 ring-black/5 transition focus:outline-none data-[closed]:scale-95 data-[closed]:transform data-[closed]:opacity-0 data-[enter]:duration-100 data-[leave]:duration-75 data-[enter]:ease-out data-[leave]:ease-in  border-solid border-[1px] ${
                themeMode === "dark"
                  ? " bg-[#2a2939] border-white-09 shadow-theme-popup-shadow "
                  : "bg-[#FFFFFF] border-black-09 shadow-black-2-shadow"
              }`}
            >
              <div className="py-1">
                {options.map((group) => (
                  <div key={group.page}>
                    <div
                      className={`flex-shrink-0 flex justify-between px-2 py-1 min-w-0 min-h-[2.25rem] text-left rounded-md cursor-pointer font-bold text-blue-500`}
                    >
                      {group.page}
                    </div>
                    {group.questions.map((item) => (
                      <button
                        key={item.question}
                        className={`flex-shrink-0 flex justify-between px-2 py-1 min-w-0 min-h-[2.25rem] text-left rounded-md cursor-pointer ${
                          themeMode === "dark"
                            ? "hover:bg-[#333240] text-white"
                            : "hover:bg-[#EBEBEB] text-black"
                        }`}
                        onClick={() => {
                          // setSecondSelectedQuestion(item);
                          setIsOpenSecondMenu(false);
                          // uppdateSankeyChart('second', item);
                          setSecondSelectedQuestion(item);
                        }}
                      >
                        {item.question}
                      </button>
                    ))}
                  </div>
                ))}
              </div>
            </div>
          )}
          <div className="w-64 break-words whitespace-wrap my-4">
            {secondSelectedQuestion ? secondSelectedQuestion.question : ""}
          </div>
        </div>
        <div
          className="relative inline-block text-left mt-4 lg:mt-0"
          ref={thirdMenuRef}
        >
          <button
            onClick={() => {
              setIsOpenThirdMenu(!isOpenThirdMenu);
              if (isOpenFirstMenu) {
                setIsOpenFirstMenu(false);
              }
              if (isOpenSecondMenu) {
                setIsOpenSecondMenu(false);
              }
            }}
            disabled={!secondSelectedQuestion}
            className={`hulyButton font-medium-14 h-[1.5rem] lg:h-[2rem] w-64 px-2 border rounded-[0.375rem] cursor-pointer flex justify-center  items-center gap-2 ${
              themeMode === "dark"
                ? "border-[#d1d5de0a] bg-[#d1d5de0d] hover:bg-[#d1d5de0a] hover:text-[#fff] text-white-8"
                : "border-[#1725471a] bg-[#1725470d] hover:bg-[#1725471a] hover:text-[#000] text-black-8"
            }`}
          >
            <div className="truncate">
              {thirdSelectedQuestion
                ? thirdSelectedQuestion.question
                : "Add a question"}
            </div>
            <svg
              className="w-5 h-5 ml-2 -mr-1"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 20 20"
              fill="currentColor"
              aria-hidden="true"
            >
              <path
                fillRule="evenodd"
                d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                clipRule="evenodd"
              />
            </svg>
          </button>

          {isOpenThirdMenu && (
            <div
              className={`absolute left-1 z-[99999999]  w-64 h-[250px] overflow-y-scroll  origin-top-right rounded-md shadow-2xl ring-1 ring-black/5 transition focus:outline-none data-[closed]:scale-95 data-[closed]:transform data-[closed]:opacity-0 data-[enter]:duration-100 data-[leave]:duration-75 data-[enter]:ease-out data-[leave]:ease-in  border-solid border-[1px] ${
                themeMode === "dark"
                  ? " bg-[#2a2939] border-white-09 shadow-theme-popup-shadow "
                  : "bg-[#FFFFFF] border-black-09 shadow-black-2-shadow"
              }`}
            >
              <div className="py-1">
                {options.map((group) => (
                  <div key={group.page}>
                    <div
                      className={`flex-shrink-0 flex justify-between px-2 py-1 min-w-0 min-h-[2.25rem] text-left rounded-md cursor-pointer font-bold text-blue-500`}
                    >
                      {group.page}
                    </div>
                    {group.questions.map((item) => (
                      <button
                        key={item.question}
                        className={`flex-shrink-0 flex justify-between px-2 py-1 min-w-0 min-h-[2.25rem] text-left rounded-md cursor-pointer ${
                          themeMode === "dark"
                            ? "hover:bg-[#333240] text-white"
                            : "hover:bg-[#EBEBEB] text-black"
                        }`}
                        onClick={() => {
                          // setThirdSelectedQuestion(item);
                          setIsOpenThirdMenu(false);
                          // uppdateSankeyChart('third', item);
                          setThirdSelectedQuestion(item);
                        }}
                      >
                        {item.question}
                      </button>
                    ))}
                  </div>
                ))}
              </div>
            </div>
          )}
          <div className="w-64 break-words whitespace-wrap my-4">
            {thirdSelectedQuestion ? thirdSelectedQuestion.question : ""}
          </div>
        </div>
      </div>
      <div
        id="svg-sankey"
        ref={chartRef}
        style={{ width: "100%", height: "600px" }}
      ></div>
    </div>
  );
}
